module.exports = __webpack_public_path__ + "static/Vena_Pi-a2f06a739a988f6122d366b331da0f30.png";